import { isElementType } from '@lumapps/wrex/slate/utils/isElementType';

import { Headline } from '../components/blocks/Headline';

export const isHeadline = isElementType(Headline);
